[
  {
    "id": "dawnmere_to_crossroads",
    "fromLocationId": "dawnmere",
    "toLocationId": "kings_road_crossroads",
    "travelDays": 1,
    "locked": false
  },
  {
    "id": "crossroads_to_ironwatch",
    "fromLocationId": "kings_road_crossroads",
    "toLocationId": "ironwatch_fortress",
    "travelDays": 1,
    "locked": false
  },
  {
    "id": "crossroads_to_ruined_temple",
    "fromLocationId": "kings_road_crossroads",
    "toLocationId": "ruined_temple_first_dawn",
    "travelDays": 2,
    "locked": false
  },
  {
    "id": "crossroads_to_crownreach",
    "fromLocationId": "kings_road_crossroads",
    "toLocationId": "crownreach",
    "travelDays": 2,
    "locked": false
  },
  {
    "id": "crownreach_to_rivergate",
    "fromLocationId": "crownreach",
    "toLocationId": "rivergate",
    "travelDays": 1,
    "locked": false
  },
  {
    "id": "dawnmere_to_goldenfields",
    "fromLocationId": "dawnmere",
    "toLocationId": "goldenfields",
    "travelDays": 1,
    "locked": false
  },
  {
    "id": "ironwatch_to_blacktooth_wastes",
    "fromLocationId": "ironwatch_fortress",
    "toLocationId": "blacktooth_wastes",
    "travelDays": 2,
    "locked": false
  },
  {
    "id": "ironwatch_to_starbow_academy",
    "fromLocationId": "ironwatch_fortress",
    "toLocationId": "starbow_academy",
    "travelDays": 3,
    "locked": false
  },
  {
    "id": "starbow_to_moonspire",
    "fromLocationId": "starbow_academy",
    "toLocationId": "moonspire",
    "travelDays": 1,
    "locked": false
  },
  {
    "id": "starbow_to_cloudwood_aerie",
    "fromLocationId": "starbow_academy",
    "toLocationId": "cloudwood_aerie",
    "travelDays": 2,
    "locked": false
  },

  {
    "id": "rivergate_to_sevenfold_tower",
    "fromLocationId": "rivergate",
    "toLocationId": "sevenfold_tower",
    "travelDays": 2,
    "locked": true,
    "unlock": { "knowledgeAny": ["roads_charted"] }
  },
  {
    "id": "crownreach_to_deepgate",
    "fromLocationId": "crownreach",
    "toLocationId": "deepgate",
    "travelDays": 2,
    "locked": true,
    "unlock": { "knowledgeAny": ["roads_charted"] }
  },
  {
    "id": "temple_to_whispering_lake",
    "fromLocationId": "ruined_temple_first_dawn",
    "toLocationId": "whispering_lake",
    "travelDays": 2,
    "locked": true,
    "unlock": { "knowledgeAny": ["roads_charted"] }
  },
  {
    "id": "cloudwood_to_thornwatch",
    "fromLocationId": "cloudwood_aerie",
    "toLocationId": "thornwatch",
    "travelDays": 2,
    "locked": true,
    "unlock": { "knowledgeAny": ["roads_charted"] }
  },
  {
    "id": "rivergate_to_windroad_market",
    "fromLocationId": "rivergate",
    "toLocationId": "windroad_market",
    "travelDays": 2,
    "locked": true,
    "unlock": { "knowledgeAny": ["roads_charted"] }
  },

  {
    "id": "deepgate_to_stonehall",
    "fromLocationId": "deepgate",
    "toLocationId": "stonehall",
    "travelDays": 1,
    "locked": false
  },
  {
    "id": "stonehall_to_emberforge",
    "fromLocationId": "stonehall",
    "toLocationId": "emberforge",
    "travelDays": 1,
    "locked": false
  },
  {
    "id": "deepgate_to_glass_library",
    "fromLocationId": "deepgate",
    "toLocationId": "glass_library",
    "travelDays": 1,
    "locked": false
  },
  {
    "id": "sevenfold_to_glass_library",
    "fromLocationId": "sevenfold_tower",
    "toLocationId": "glass_library",
    "travelDays": 1,
    "locked": false
  },
  {
    "id": "glass_library_to_rift_observatory",
    "fromLocationId": "glass_library",
    "toLocationId": "rift_observatory",
    "travelDays": 1,
    "locked": false
  },
  {
    "id": "thornwatch_to_greenveil",
    "fromLocationId": "thornwatch",
    "toLocationId": "greenveil",
    "travelDays": 1,
    "locked": false
  },
  {
    "id": "greenveil_to_elderroot_grove",
    "fromLocationId": "greenveil",
    "toLocationId": "elderroot_grove",
    "travelDays": 1,
    "locked": false
  },
  {
    "id": "greenveil_to_whispering_lake",
    "fromLocationId": "greenveil",
    "toLocationId": "whispering_lake",
    "travelDays": 2,
    "locked": false
  },
  {
    "id": "whispering_lake_to_hall_ancestors",
    "fromLocationId": "whispering_lake",
    "toLocationId": "hall_ancestors",
    "travelDays": 1,
    "locked": false
  },
  {
    "id": "hall_ancestors_to_windroad_market",
    "fromLocationId": "hall_ancestors",
    "toLocationId": "windroad_market",
    "travelDays": 1,
    "locked": false
  },
  {
    "id": "windroad_to_camp_seven_banners",
    "fromLocationId": "windroad_market",
    "toLocationId": "camp_seven_banners",
    "travelDays": 1,
    "locked": false
  },
  {
    "id": "camp_to_red_steppe",
    "fromLocationId": "camp_seven_banners",
    "toLocationId": "red_steppe",
    "travelDays": 1,
    "locked": false
  },

  {
    "id": "emberforge_to_colossus_vale",
    "fromLocationId": "emberforge",
    "toLocationId": "colossus_vale",
    "travelDays": 2,
    "locked": true,
    "unlock": { "knowledgeAny": ["giants_road_known"] }
  },
  {
    "id": "cloudwood_to_cinderpeak",
    "fromLocationId": "cloudwood_aerie",
    "toLocationId": "cinderpeak",
    "travelDays": 2,
    "locked": true,
    "unlock": { "knowledgeAny": ["dragons_road_known"] }
  },
  {
    "id": "camp_to_mire_hunger",
    "fromLocationId": "camp_seven_banners",
    "toLocationId": "mire_hunger",
    "travelDays": 1,
    "locked": true,
    "unlock": { "knowledgeAny": ["trolls_road_known"] }
  },
  {
    "id": "hall_ancestors_to_ashen_necropolis",
    "fromLocationId": "hall_ancestors",
    "toLocationId": "ashen_necropolis",
    "travelDays": 2,
    "locked": true,
    "unlock": { "knowledgeAny": ["undead_road_known"] }
  },
  {
    "id": "red_steppe_to_nightweb",
    "fromLocationId": "red_steppe",
    "toLocationId": "nightweb_underrealm",
    "travelDays": 2,
    "locked": true,
    "unlock": { "knowledgeAny": ["dark_elves_road_known"] }
  },
  {
    "id": "rift_observatory_to_shattered_veil",
    "fromLocationId": "rift_observatory",
    "toLocationId": "shattered_veil",
    "travelDays": 3,
    "locked": true,
    "unlock": { "knowledgeAny": ["demons_road_known"] }
  },
  {
    "id": "red_steppe_to_shattered_veil",
    "fromLocationId": "red_steppe",
    "toLocationId": "shattered_veil",
    "travelDays": 2,
    "locked": true,
    "unlock": { "knowledgeAny": ["demons_road_known"] }
  },
  {
    "id": "shattered_veil_to_ebon_citadel",
    "fromLocationId": "shattered_veil",
    "toLocationId": "ebon_citadel",
    "travelDays": 2,
    "locked": true,
    "unlock": {
      "knowledgeAny": ["ebon_citadel_approach_known", "ebon_citadel_north_cistern_route"]
    }
  },
  {
    "id": "nightweb_to_ebon_citadel",
    "fromLocationId": "nightweb_underrealm",
    "toLocationId": "ebon_citadel",
    "travelDays": 3,
    "locked": true,
    "unlock": {
      "knowledgeAny": ["ebon_citadel_approach_known", "ebon_citadel_north_cistern_route"]
    }
  }
]
